import { JsonObject, JsonProperty } from "json2typescript"
import { OpeningHours } from ".";

//** Model kontaktního místa * /
@JsonObject("ContactPlace")
export class ContactPlace {
  @JsonProperty('id', Number)
  id: number = 0
  @JsonProperty('name', String)
  name: string = "";
  @JsonProperty('adress', String)
  adress: string = "";
  @JsonProperty('operator', String)
  operator: string = "";
  @JsonProperty('remark', String)
  remark: string = "";
  @JsonProperty('phone', String)
  phone: string = "";
  @JsonProperty('email', String)
  email: string = "";
  @JsonProperty('openingHours', [])
  openingHours: OpeningHours[] = [];
  @JsonProperty('lat', Number)
  lat: number = 0;
  @JsonProperty('lon', Number)
  lon: number = 0;

  isExpanded: boolean = false;
}
